import { format, formatDistanceStrict } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { es } from 'date-fns/locale';

export const parseISO8601DateTime = (dateTime: string): Date => zonedTimeToUtc(dateTime, 'Europe/London');

const zeroPadded = (timeFraction: number): string => (timeFraction < 10 ? `0${timeFraction}` : String(timeFraction));
export const diffForHumans = (createdAt: string): string =>
  formatDistanceStrict(parseISO8601DateTime(createdAt), new Date(), { locale: es });

export const formatDurationInSeconds = (durationInSeconds: number): string => {
  const hours = Math.floor(durationInSeconds / 3600);
  const minutes = Math.floor((durationInSeconds % 3600) / 60);
  const seconds = Math.floor((durationInSeconds % 3600) % 60);

  const hDisplay = hours > 0 ? `${zeroPadded(hours)}:` : '';
  const mDisplay = minutes > 0 ? `${zeroPadded(minutes)}:` : '00:';
  const sDisplay = seconds > 0 ? `${zeroPadded(seconds)}` : '00';

  return hDisplay + mDisplay + sDisplay;
};

export const formattedDate = (date: string): string =>
  format(parseISO8601DateTime(date), 'd MMMM, yyyy', { locale: es });
